export default __webpack_public_path__ + "static/media/SeedFundSchemeLogo.a7455876.svg";